import React, { useEffect, useState } from 'react';

function initialsOf(user) {
  const base = (user?.full_name || user?.username || user?.email || '?').trim();
  const parts = base.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return base.slice(0, 2).toUpperCase();
}

export default function UserAvatar({
  user,
  src,
  alt,
  className = 'h-8 w-8',
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const imageSrc = src || user?.profile_photo_url || null;
  const label = alt || user?.full_name || user?.username || user?.email || 'User avatar';

  useEffect(() => {
    setImageFailed(false);
  }, [imageSrc]);

  return (
    <span
      className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-gradient-to-b from-[#5b9bf7] to-[var(--accent-strong)] text-xs font-bold text-white shadow-sm ${className}`}
      title={label}
    >
      {imageSrc && !imageFailed ? (
        <img src={imageSrc} alt={label} onError={() => setImageFailed(true)} className="h-full w-full object-cover" />
      ) : (
        <span aria-hidden="true">{initialsOf(user)}</span>
      )}
    </span>
  );
}
